import { render, staticRenderFns } from "./LegalAtlas.vue?vue&type=template&id=12ab7633&scoped=true&"
import script from "./LegalAtlas.vue?vue&type=script&lang=js&"
export * from "./LegalAtlas.vue?vue&type=script&lang=js&"
import style0 from "./LegalAtlas.vue?vue&type=style&index=0&id=12ab7633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab7633",
  null
  
)

export default component.exports